import {useSuspenseQuery} from '@tanstack/react-query';

import {api} from '@/lib/ky';

import {checklistTemplateSchema} from '../utils/schemas/checklist';

import {checklistTemplateKeys} from './queryKeys';

import type {
  QueryConfig,
  ExtractFnReturnType,
  QueryConfig2,
} from '@/lib/react-query';

export const getChecklistTemplate = async (id: string) => {
  const data = await api.get(`checklists/${id}`).json();
  return checklistTemplateSchema.parse(data);
};

export const useChecklistTemplate = (
  id: string,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: checklistTemplateKeys.detail(id),
    queryFn: () => getChecklistTemplate(id),
  });
};
export const useChecklistTemplateLoader = (
  config: QueryConfig2<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getChecklistTemplate;
